import Flex, { type FlexProps } from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { formatDate } from "@shared/utils/dates/formatting";
import { useTranslation } from "@shared/utils/internationalization";
import StatusBadge from "../StatusBadge/StatusBadge.web";
import { SaleStartsOnBadgeProps } from "./SaleStartsOnBadge.props";

const SaleStartsOnBadge = ({
  saleStartsOn,
  isOnSale,
  timezone,
  ...props
}: SaleStartsOnBadgeProps & FlexProps) => {
  const { t } = useTranslation("common");

  return !isOnSale && saleStartsOn && timezone ? (
    <Flex data-testid="sale-starts-on-badge" {...props}>
      <StatusBadge status="info" borderRadius="sm">
        <Text>
          {t("Sale starts on ") +
            formatDate({
              date: saleStartsOn,
              timezone,
              format: "EEEE MMM d, yyyy | h:mm a zzz",
            })}
        </Text>
      </StatusBadge>
    </Flex>
  ) : (
    <></>
  );
};

export default SaleStartsOnBadge;
